import React from 'react'
import PropTypes from 'prop-types'
import { isAgreeAndDonateLabel } from '../utility/localizer.js';
import { Button } from '@paypalcorp/pp-react';

class GuestSubmitButton extends React.Component {

	getDonateButtonLabel = () => {
		let {
			passwordFieldsOpen = false,
			labels: {
				donatenow,
				donatenowrec,
				agreeanddonate,
				agreeanddonatenowrec
			} = {},
			country
		} = this.props;
		const useAgreeAndDonateLabel = passwordFieldsOpen || isAgreeAndDonateLabel(country);

		let donateLabel;
		if (this.props.isRecurring) {
			donateLabel = donatenowrec;

			if (useAgreeAndDonateLabel) {
				donateLabel = agreeanddonatenowrec;
			}
			donateLabel = donateLabel && donateLabel.replace('{amount}', this.props.amount);
		} else {
			donateLabel = donatenow;
			if (useAgreeAndDonateLabel) {
				donateLabel = agreeanddonate;
			}
		}

		return donateLabel;
	}

	render () {
		return (
			<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
				<Button
					className="btn-wide"
					id="guestPaymentBtn"
					disabled={this.props.disabled}
					onClick={this.props.handleClick}
				>{this.getDonateButtonLabel()}
				</Button>
			</div>
		);
	}
}

GuestSubmitButton.propTypes = {
	labels: PropTypes.object,
	amount: PropTypes.string,
	country: PropTypes.string,
	disabled: PropTypes.bool,
	isRecurring: PropTypes.bool,
	handleClick: PropTypes.func,
	passwordFieldsOpen: PropTypes.bool,
};

export default GuestSubmitButton
